import React, { useContext, useMemo, useState } from "react";
import { Review } from "../types";
import { ReviewCard } from "./reviewCard";
import EmptyCampaign from "../assets/emptyCampaign.svg";
import { NewReviewModal } from "./newReviewModal";
import { ReviewFrontend } from "../syncedTypes";
import * as motion from "motion/react-client";
import { CampaignModalContext, DashboardContext } from "../Pages/dashboard";
import { LoadingZipFileModal } from "./loadingZipFile";
import { isMobile } from "react-device-detect";

export interface DashboardContentSectionProps {
  reviews: ReviewFrontend[];
}

export const ZipFileLoadingContext = React.createContext<{
  isOpen: boolean;
  setIsOpen: (newState: boolean) => void;
}>({
  isOpen: false,
  setIsOpen: (newVal: boolean) => undefined,
});

export const DashboardContentSection = ({
  reviews,
}: DashboardContentSectionProps) => {
  const reviewCards = useMemo(() => {
    return reviews.map((el) => <ReviewCard review={el} key={el.id} />);
  }, [reviews]);

  const [zipFileLoadingIsOpen, setZipFileLoadingIsOpen] =
    useState<boolean>(false);

  const { isExpanded } = useContext(DashboardContext);
  const { isOpen} =
      useContext(CampaignModalContext);

  const staticContent = useMemo(() => {
    return (
      <div className="emptyCampaignGraphicContainer">
        <div className="centerAlginColumn">
          <img
            src={EmptyCampaign}
            style={{ height: "30rem", width: "30rem", overflow: "hidden" }}
          />
          <p>No reviews added</p>
        </div>
      </div>
    );
  }, []);
  return (
    <ZipFileLoadingContext.Provider
      value={{
        isOpen: zipFileLoadingIsOpen,
        setIsOpen: setZipFileLoadingIsOpen,
      }}
    >
      {reviewCards.length ? (
        <motion.div
          layout
          transition={isExpanded ? { duration: 0 } : { duration: 1 }}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            paddingRight: isMobile ? '5vw' : "2rem",
            paddingLeft: isMobile ? '5vw' : "3rem",
            paddingBottom: "4rem",
            gap: "1rem",
            flexDirection: isExpanded ? "column" : "row",
            touchAction: isOpen ? 'none' : undefined
          }}
        >
          {reviewCards}
        </motion.div>
      ) : (
        staticContent
      )}
      <LoadingZipFileModal />
    </ZipFileLoadingContext.Provider>
  );
};
